/* eslint-disable camelcase */
import { CarMileageEntry, ServiceReport } from '../../models';
import { GET_SERVICE_REPORT, RESET_SERVICE_REPORT } from '../constants/serviceReport';

// eslint-disable-next-line import/prefer-default-export
export const getServiceReport = (data) => {
  const { service_report } = data;
  if (!service_report) {
    return (dispatch) => {
      dispatch({ type: RESET_SERVICE_REPORT });
    };
  }

  const {
    id,
    oil_condition,
    brake_fluid_condition,
    coolant_condition,
    tires_condition,
    lights_condition,
    mileage,
  } = service_report;

  const mileageEntry = mileage
    ? new CarMileageEntry(mileage.id, mileage.mileage_in_kilometers)
    : null;

  const serviceReport = new ServiceReport(
    id,
    oil_condition,
    brake_fluid_condition,
    coolant_condition,
    tires_condition,
    lights_condition,
    mileageEntry,
  );

  return (dispatch) => {
    dispatch({
      type: GET_SERVICE_REPORT,
      ...serviceReport,
    });
  };
};
